import { Component, OnInit, Inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { SidebarService } from '@layout/core/services';
import { AppLayoutStateService, CurrentUserService } from '@core/services';
import { CurrentUser } from '@shared/interfaces';
import { DOCUMENT } from '@angular/common';
import { ToasterPositionEnum } from '@shared/enums';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    isSidebarCollapsed = true;
    isLoading: boolean = true;
    hasError: boolean = false;
    currentUser: CurrentUser | null = null;
    toasterPositions = ToasterPositionEnum;

    isUnauthorized: boolean = false;
    isVisible: boolean = true;
    
    constructor(
        private appLayoutStateService: AppLayoutStateService,
        private auth: AuthService,
        private sidebarService: SidebarService,
        private currentUserService: CurrentUserService,
        private primengConfig: PrimeNGConfig,
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private document: Document
        ) {

        this.sidebarService.isCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isSidebarCollapsed = isCollapsed;
        });

        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser = user;
            this.isLoading = false;
        });

        this.currentUserService.currentUserError$.subscribe(hasError => {
            this.currentUser = null;
            this.isLoading = false;
            this.hasError = hasError;
        });

        this.currentUserService.isUnauthorized$.subscribe(value => {
            this.isUnauthorized = value;
            this.currentUser = null;
            this.isLoading = false;
        });

        this.auth.isAuthenticated$.subscribe((isAuthenticated) => {
            if (isAuthenticated) {
                this.currentUserService.initializeCurrentUser();
            }
        });

        
    }

    async ngOnInit() {
        this.primengConfig.ripple = false;
        let isInModalMode = (window.location !== window.parent.location);
        if(this.document.documentURI.includes('modal')){
            isInModalMode = true;
        }
        this.updateLayoutState(isInModalMode);
        this.route.queryParams.subscribe((params) => {
            if (params['showAsModal'] == "true") {
                this.updateLayoutState(true);
            }
        });
    }

    updateLayoutState(isInModalMode: boolean) {
        this.isVisible = !isInModalMode;
        this.appLayoutStateService.setModalMode(isInModalMode);
    }
}
